const mpi = Object.create(null);
const canvasDefaultSize = {
  width: 600,
  height: 600
}

Object.defineProperties(mpi, {
  'canvas_width': {
    value: canvasDefaultSize.width,
    writable: canvasDefaultSize.height,
  },
  'canvas_height': {
    value: 600,
    writable: true,
  },
  'settings': {
    get: function () {
      return {
        'canvas': this.m_canvas || null,
        'images_arr': this.m_images_arr || null
      }
    },
    set: function (data) {
      if (data['canvas']) this.m_canvas = data['canvas'];
      if (data['images_arr']) this.m_images_arr = data['images_arr'];
    }
  }
});

mpi.init = function (canvasSize) {
  document.getElementById('mpi-canvas')?.remove();
  this.canvas_width = canvasSize?.width || canvasDefaultSize.width;
  this.canvas_height = canvasSize?.height || canvasDefaultSize.height;
  const canvas = document.createElement('canvas');
  canvas.width = this.canvas_width;
  canvas.height = this.canvas_height;
  canvas.setAttribute('id', 'mpi-canvas');
  canvas.style.display = 'none';
  document.body.appendChild(canvas);
  this.settings = {'canvas': document.getElementById('mpi-canvas')};
};

mpi.getImages = function (imagesParentNodeSelector, one) {
  if (imagesParentNodeSelector && typeof imagesParentNodeSelector === 'string') {
    let imagesParentNode = document.querySelectorAll(imagesParentNodeSelector);

    if (imagesParentNode) {
      let imagesCollection = imagesParentNode[ one ? 0 : imagesParentNode.length-1].querySelectorAll('img');

      imagesCollection = [... imagesCollection, ...imagesParentNode[ one ? 0 : imagesParentNode.length-1].querySelectorAll('canvas')];
      if (imagesCollection && imagesCollection.length) {
        return Array.prototype.slice.call(imagesCollection);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }
  else {
    return null;
  }
};

mpi.setImages = function (imagesArr) {
  let images = [...imagesArr];
  images.sort(function (xEl, yEl) {
    const x = parseInt(xEl.style.zIndex);
    const y = parseInt(yEl.style.zIndex);
    if ( x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  });
  if (imagesArr && Array.isArray(imagesArr)) {
    this.settings = {'images_arr': imagesArr};
  }
};

mpi.mergeImages = function (top) {
  if (this.settings.canvas && this.settings.images_arr) {
    const ctx = this.settings.canvas.getContext("2d");
    if (ctx) {
      ctx.clearRect(0, 0, this.settings.canvas.width, this.settings.canvas.height);
      if (this.settings.images_arr[0].tagName === 'CANVAS') {
        this.settings.images_arr.push(this.settings.images_arr.shift());
      }
      this.settings.images_arr.forEach(function (item) {
        const resizedCanvas = document.createElement('canvas');
        const resizedCtx = resizedCanvas.getContext("2d");
        if (item.style.display === 'none') {
          return;
        } else {
          try {
            if (item.classList.contains('canvasBox') || item.classList.contains('canvasBoxSaveDrawer')) {
              resizedCanvas.width = mpi.canvas_width;
              resizedCanvas.height = mpi.canvas_height;
              const { x, y, width, height } = mpi.cropImage(item, resizedCanvas);
              resizedCtx.drawImage(item, x - 150, y + (!top ? 4 : 38), width + 300, height);
            } else if (item.classList.value.includes('canvasTextModal')) {
              resizedCanvas.width = mpi.canvas_width;
              resizedCanvas.height = mpi.canvas_height;
              console.log('top', top);
              const { x, y, width, height } = mpi.cropImage(item, resizedCanvas);
              resizedCtx.drawImage(item, x, y + (top ? top : 0), width, height);
            } else {
              resizedCanvas.width = mpi.canvas_width;
              resizedCanvas.height = mpi.canvas_height;
              const { x, y, width, height } = mpi.cropImage(item, resizedCanvas, true);
              let canvasYFix = item.classList.contains('canvas') ? ((height / 100) * 0.45) : 0;
              resizedCtx.drawImage(item, x, y + canvasYFix, width, height);
            }
          } catch (e) {
            console.log(e);
          }
        }

        ctx.drawImage(resizedCanvas, 0, 0);
      });
    }
  }
};

mpi.cropImage = function(img, canvas) {
  // get the scale
  const scale = Math.min(canvas.width / img.width, canvas.height / img.height );
  // get the top left position of the image
  const x = (canvas.width / 2) - (img.width / 2) * scale;
  const y = (canvas.height / 2) - (img.height / 2) * scale;
  return {
    x,
    y,
    width: img.width * scale,
    height: img.height * scale
  };
};

mpi.getMergedImage = function (nodeSelector, one, top) {
  if (this.settings.canvas) {
    const images = this.getImages(nodeSelector, one);
    if (images) {
      this.setImages(images);
      this.mergeImages(top);
      return this.settings.canvas.toDataURL();
    }
  }
};

// mpi.init();
export default mpi;

// mpi.getMergedImage('image parent div el'); return image in base64
